export var NativeStreamStatKind;
(function (NativeStreamStatKind) {
    NativeStreamStatKind["NATIVE_STREAM_STAT_KIND_UNSPECIFIED"] = "NATIVE_STREAM_STAT_KIND_UNSPECIFIED";
    NativeStreamStatKind["NATIVE_STREAM_STAT_KIND_NDV"] = "NDV";
    NativeStreamStatKind["NATIVE_STREAM_STAT_KIND_QUANTILES"] = "QUANTILES";
    NativeStreamStatKind["NATIVE_STREAM_STAT_KIND_TOPK"] = "TOPK";
})(NativeStreamStatKind || (NativeStreamStatKind = {}));
